import React, {useEffect, useState} from 'react';
import '../Loader.scss';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import _ from 'lodash';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import TimezoneSelect from 'react-timezone-select';
import Select from 'react-select';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Subscriptions from '../Subscriptions/Subscriptions';
const api = process.env.REACT_APP_API_URL;

function ProgramSettings({programId, active, title, onDataChange}) {
    const [isLoading, setIsLoading] = React.useState(false);

    const [isSubModalOpen, setIsSubModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        birth_date: null,
        started_at: null
    });
    const [originalData, setOriginalData] = useState(formData);

    const genderOptions = [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' },
        { value: 'other', label: 'Other' }
    ];

    const programOptions = [
        { value: 'role0', label: 'Free Plan' },
        { value: 'role1', label: 'Premium Plan' },
        { value: 'role2', label: 'Unlimited Plan' }
    ];

    useEffect(() => {
        if (active) {
            setIsLoading(true);
            axios.post(`${api}/user/dashboard/${programId}`, {}, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("auth_token")}`
                }
            })
            .then(response => {
                response.data.data.birth_date = response.data.data.birth_date ? dayjs(response.data.data.birth_date) : null;
                response.data.data.started_at = response.data.data.started_at ? dayjs(response.data.data.started_at) : null;
                setFormData(response.data.data);
                setOriginalData(response.data.data);
            })
            .finally(() => setIsLoading(false));
        }
        }, [active]);

    useEffect(() => {
        onDataChange(!_.isEqual(formData, originalData));
    }, [formData]);

    const saveChanges = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        let data = {...formData};
        if (data.birth_date && typeof data.birth_date.format === 'function') {
            data.birth_date = data.birth_date.format('YYYY-MM-DD');
        }

        if (data.started_at && typeof data.started_at.format === 'function') {
            data.started_at = data.started_at.format('YYYY-MM-DD HH:mm:ss');
        }

        try {
            await axios.post(`${api}/user/data/update/${programId}`, data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("auth_token")}`
                }
            });
            setOriginalData(formData);
            toast.success("Changes saved successfully!");
            onDataChange(false);
        } catch (error) {
            toast.error("An error occurred while saving changes. Please try again.");
        } finally {
            setIsLoading(false);
        }
    }

    const toCustomerPortal = async (e) => {
        e.preventDefault();

        try {
            e.target.disabled = true;
            await axios.post(`${api}/stripe/create-billing-portal-link`, {
                stripeCID: formData.stripe_customer_id
            }).then(response => {
                window.location.href = response.data.url;
            });
        }
        catch (error) {
            toast.error("An error occurred while redirecting to the customer portal. Please try again.");
        }
        finally {
            e.target.disabled = false;
        }
    }

  return (
    <>
    <form onSubmit={saveChanges}>
    <h3>{title}</h3>
    <div className='form'>
        <header>
            <h4>Account Information</h4>
        </header>
        <div className='inputs'>
            <div className='element input-group multiple gap'>
                <input 
                    className={'input' + (formData.name !== originalData.name ? ' accent' : '')}
                    type="text" placeholder="Name" value={formData.name} 
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                />
                <input 
                    className={'input' + (formData.email !== originalData.email ? ' accent' : '')}
                    type="email" placeholder="Email" value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                />
            </div>
            <div className='element input-group multiple gap'>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        className={'input' + (formData.birth_date !== originalData.birth_date ? ' accent' : '')}
                        value={formData.birth_date}
                        onChange={(newValue) => {setFormData({...formData, birth_date: newValue})}}
                    />
                </LocalizationProvider>
                <TimezoneSelect
                    className={'input' + (formData.timezone !== originalData.timezone ? ' accent' : '')}
                    classNamePrefix={'select'}
                    value={formData.timezone}
                    onChange={(e) => setFormData({...formData, timezone: e.value})}
                    menuPosition="absolute"
                    menuPlacement='auto'
                    menuPortalTarget={document.body}
                    required
                />
            </div>

            <div className='element input-group multiple gap'>
                <PhoneInput 
                    value={'+' + formData.phone_number} 
                    onChange={() => {}}
                    disabled
                />
                <Select
                className={'input' + (formData.gender !== originalData.gender ? ' accent' : '')}
                classNamePrefix={'select'}
                options={genderOptions}
                menuPortalTarget={document.body}
                value={genderOptions.find(option => option.value === formData.gender)}
                onChange={(e) => setFormData({...formData, gender: e.value})}
                />
            </div>
        </div>
        
    </div>
    <div className='form' onSubmit={(e) => {e.preventDefault()}}>
        <header>
            <h4>Program Information</h4>
        </header>
        <div className='inputs'>
            <div className='element input-group multiple gap'>
                <label htmlFor="startdate">Start date</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={formData.started_at}
                        onChange={() => {}}
                        disabled
                    />
                </LocalizationProvider>
            </div>
            <div className='element input-group multiple gap'>
                <label htmlFor="plan">Your plan</label>
                <Select
                    className='input'
                    classNamePrefix={'select'}
                    options={programOptions}
                    value={programOptions.find(option => option.value === formData.role) || programOptions[0]}
                    onChange={() => {}}
                    isDisabled
                />
            </div>
            {formData.role == "role0" ? (
                <div className='element input-group multiple reverse gap'>
                    <label>Upgrade your plan</label>
                    <button className='btn primary' onClick={(e) => {e.preventDefault(); setIsSubModalOpen(true);}}>See Options</button>
                </div>
            ) : (
                <div className='element input-group multiple reverse gap'>
                    <label>Manage your subscription</label>
                    <button className='btn primary' onClick={toCustomerPortal}>Stripe Customer Portal</button>
                </div>
            )}
        </div>
    </div>
    {!_.isEqual(formData, originalData) && !isLoading ? (
        <div className='element inputs'>
            <input 
                type='submit' 
                className='btn primary submit right' 
                value="Save Changes"
            />
        </div>
    ) : null}
    {isLoading ? (
    <div className='loader bg'>
        <div className='loader spinner'></div>
    </div>
    ) : null}
    </form>
    <Modal
      open={isSubModalOpen}
      sx={{
        overflow: 'auto',
        maxHeight: '100vh'
      }}
      >
        <Box className="content modal"
        sx={{
            overflowY: 'auto'
        }}
        >
            <Subscriptions program={programId} />
            <button className='btn close accent' onClick={() => setIsSubModalOpen(false)}/>
        </Box>
    </Modal>
    </>
  )
}

export default ProgramSettings